import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { dev } from "../../../features/network/ApiCall";
import { GetFormattedDate } from "../../../constant/DateFormatEdit";

const CommentItem = ({ item }: { item: any }) => {
  const files = item?.fileName ? item?.fileName.split(",") : [];

  return (
    <Row>
      <Col xs={12}>
        <b style={styles.username}>{item?.name}</b>
        {item?.createdDate && (
          <span style={styles.datetime}>
            {'  '}
            {GetFormattedDate(item?.createdDate, 'DD-MM-YYYY @ HH : mm')}
          </span>
        )}
      </Col>
      <Col xs={12} style={{ paddingLeft: '1rem' }}>
        <p style={styles.remarks}>
          {item?.reason
            ? item?.reason === 'Other'
              ? item?.message
              : item?.reason
            : item?.message}
        </p>
      </Col>

      <Col xs={12} style={(styles.msgBody, styles.border)}>
        {files.length > 0 && (
          <Row>
            <Col xs={12}>
              <b style={{ color: '#000' }}>Attachments</b>
            </Col>
            {files.map((item: any, index: any) => {
              return (
                <Col xs={12} sm={12} style={{ marginBottom: '0.5rem' }}>
                  <a
                    href={`${dev}/fileUpload/downloadFile?file=${item}`}
                    style={{ color: 'blue' }}
                  >
                    {item}
                  </a>
                </Col>
              );
            })}
          </Row>
        )}
      </Col>
    </Row>
  );
};

const styles: any = {
  container: {
    margin: 1,
    backgroundColor: "#f1f2f1",
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  commentsSection: { padding: "0.5rem 1rem 1rem", backgroundColor: "#f1f2f1" },
  pl2: { paddingLeft: "1rem", paddingRight: "1rem" },
  title: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "left",
  },
  value: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
  },
  username: {
    color: "#000",
    fontSize: 14,
    fontWeight: 900,
    textTransform: "uppercase",
  },
  datetime: { color: "grey", fontSize: 12, marginLeft: "0.5rem" },
  remarks: {
    color: "#000",
    fontSize: 14,
  },
  msgBody: {
    marginBottom: "0.5rem",
  },
  border: {
    borderBottom: "solid",
    borderBottomColor: "lightgrey",
    marginBottom: "0.5rem",
  },
};

export default CommentItem;
